<template>
  <article class="search-result-video flex-col md:flex-row">
    <figure class="responsive-image rounded-sm no-overflow bg-gray-200 mb-md">
      <img :src="item.content_image" alt="" />
      <div v-if="!isWebinar">
        <SloIcon name="PlaySolid" />
      </div>
    </figure>
    <div>
      <span v-if="item.video_type" class="search-result-pill">
        {{ item.video_type }}
      </span>
      <h3>
        <a
          :href="item.url"
          @click="handleClick"
          class="c-black hover:c-blue-400 mt-md"
        >
          <ais-highlight :hit="item" attribute="content_title" />
        </a>
      </h3>
    </div>
  </article>
</template>

<script>
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    SloIcon
  },
  props: ['item', 'sendEvent'],
  computed: {
    vimeoId() {
      return this.item.content_vimeo_id;
    },
    isWebinar() {
      return this.item.content_type === 'Webinar';
    }
  },
  methods: {
    handleClick(e) {
      this.sendEvent('click', this.item, 'Global Search Video Result Clicked');

      if (!this.isWebinar) {
        e.preventDefault();
        this.$emit('show-video', this.vimeoId);
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';
@import '../../../scss/mixins';

.search-result-video {
  @media (min-width: 1024px) {
    figure {
      width: 33%;
      max-width: 190px;
      max-height: 115px;
      margin-right: 1.25em;
      flex-shrink: 0;
    }
  }

  figure div {
    position: absolute;
    width: 20%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 1000px;
    background-color: $color-blue-400;
    color: #fff;
  }

  figure div:before {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  figure .slo-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 50%;
    height: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
